import React, { useState, useEffect, useRef } from 'react';
import InputFieldFloat from "./InputFieldFloat";
import { COUNTRY_OPTIONS } from '../../constants/landingPage';
import { useGetLocationDataQuery } from '../../services/public/location';

const countries = COUNTRY_OPTIONS;

export default function PhoneInput({ label, value, onChange, name }) {
  const { data: locationData } = useGetLocationDataQuery();
  const [isOpen, setIsOpen] = useState(false);
  const selectedCountry = countries.find(c=>c.value == value) || countries.find(c => c.label === locationData?.country.toLowerCase()) || countries[0];
  const [visibleOptions, setVisibleOptions] = useState(COUNTRY_OPTIONS.slice(0, 10));
  const dropdownRef = useRef(null);

  useEffect(() => {
    onChange(selectedCountry.value);
  }, []);
  
  const handleScroll = (e) => {
    const bottom = e.currentTarget.scrollHeight >= e.currentTarget.scrollTop + e.currentTarget.clientHeight + 1;
    if (bottom && visibleOptions.length < COUNTRY_OPTIONS.length) {
      setVisibleOptions(COUNTRY_OPTIONS.slice(0, visibleOptions.length + 10));
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleCountrySelect = (country) => {
    onChange(country.value);
    setIsOpen(false);
  };

  return (
    <div className="phone-input-container">
      <div className="country-selector" ref={dropdownRef} onClick={() => setIsOpen((isOpen)=>!isOpen)}>
        <div className="selected-country">
          <div className="country-info">
            <p className="label">كود البلد</p>
            <p className="dial-code" dir="ltr">{selectedCountry.value}</p>
          </div>
          <div className="flag-arrow">
            <img 
              src={`https://hatscripts.github.io/circle-flags/flags/${selectedCountry.label.toLowerCase()}.svg`} 
              alt={selectedCountry.name} 
              width="24" 
              height="24" 
            />
            <svg width="10" height="10" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg" className={isOpen ? 'rotate' : ''}>
              <path d="M16 2L9 9 2 2" stroke="#B0B0BA" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </div>
        </div>
        
        {isOpen && (
          <div className="country-dropdown" onScroll={handleScroll}>
            {visibleOptions.map((country) => (
              <div 
                key={country.label} 
                className="country-option" 
                onClick={(e) => {
                    e.stopPropagation();
                    handleCountrySelect(country);
                }}
              >
                <img 
                  src={`https://hatscripts.github.io/circle-flags/flags/${country.label.toLowerCase()}.svg`} 
                  alt={country.name} 
                  width="24" 
                  height="24" 
                />
                <span className="dial-code" dir="ltr">{country.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      
      
    </div>
  );
}
